
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mirror",
      function () {
        return require("private-next-pages/mirror/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mirror"])
      });
    }
  